module.exports = __webpack_public_path__ + "img/aso-mokup.570ca44a.webp";